export default defineNuxtPlugin(() => {
  const { apiBaseUrl } = useRuntimeConfig().public
  const userStore = useUserStore()
  const { access_token } = storeToRefs(userStore)

  const api = $fetch.create({
    baseURL: apiBaseUrl,
    onRequest: ({ options }) => {
      if (access_token.value) {
        const headers = (options.headers ||= {})
        if (Array.isArray(headers)) {
          headers.push(['Authorization', `Bearer ${access_token.value}`])
        } else if (headers instanceof Headers) {
          headers.set('Authorization', `Bearer ${access_token.value}`)
        } else {
          headers.Authorization = `Bearer ${access_token.value}`
        }
      }
      // dispatch global loading
    },
    onResponse: () => {
      // stop global loading
    },
    onRequestError: () => {
      // dispatch global loading
    }
  })

  return {
    provide: { api: api }
  }
})
